
import { Link } from "wouter";
import { Facebook, Instagram, Twitter, Linkedin, Youtube } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Newsletter } from "./newsletter";

export function Footer() {
  const { t } = useTranslation();



  return (
    <footer
      className="relative dark:bg-slate-800">
      {/* Overlay for readability */}
      <div className="absolute inset-0 pointer-events-none z-0" />
      <div className="relative z-10">
        <Newsletter />
        <div className="py-12 overflow-hidden max-w-screen-2xl mx-auto pl-4 lg:pl-0">
          <div className="flex flex-col lg:flex-row mb-8 items-start gap-y-8 gap-x-8 md:gap-x-20 lg:gap-x-36">

            {/* Logo and Social Media */}
            <div className="flex flex-col items-center justify-center h-full pt-0 mt-0 lg:-mt-20 flex-shrink-0 min-w-0 order-last lg:order-first">
              {/* Light mode logo */}
              <img
                src="/oley-solution-logo-black.webp"
                alt="Oleyes Solutions Logo Black"
                className="h-48 w-auto object-contain block dark:hidden lg:h-56"
              />
              {/* Dark mode logo */}
              <img
                src="/oley-security-logo.webp"
                alt="Oley Security Logo"
                className="h-48 w-auto object-contain hidden dark:block lg:h-56"
              />
              {/* Social Media Icons */}
              <div className="flex space-x-5 justify-center -mt-5 lg:-mt-8">
                <a href="https://www.facebook.com/people/Oley-Security/61576328150176/" className="text-gray-400 hover:text-gray-300">
                  <span className="sr-only">Facebook</span>
                  <Facebook className="h-8 w-8" />
                </a>
                <a href="https://www.instagram.com/oleysecurity/" className="text-gray-400 hover:text-gray-300">
                  <span className="sr-only">Instagram</span>
                  <Instagram className="h-8 w-8" />
                </a>
                <a href="https://twitter.com/oleysecurity" className="text-gray-400 hover:text-gray-300">
                  <span className="sr-only">Twitter</span>
                  <Twitter className="h-8 w-8" />
                </a>
                <a href="https://www.linkedin.com/company/oleysecurity/" className="text-gray-400 hover:text-gray-300">
                  <span className="sr-only">LinkedIn</span>
                  <Linkedin className="h-8 w-8" />
                </a>
                <a href="https://www.youtube.com/channel/UCfIANTTM9VIIw9RALFdhhxA" className="text-gray-400 hover:text-gray-300">
                  <span className="sr-only">YouTube</span>
                  <Youtube className="h-8 w-8" />
                </a>
              </div>
            </div>
            {/* Company Info */}
            {/* <div className="flex-grow mb-8 lg:mb-0 flex flex-col items-start min-w-0">
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-6">{t('footer.companyName')}</h3>
              <div className="text-gray-500 dark:text-gray-400 space-y-2 text-sm">
                <div className="flex items-start">
                  <MapPin className="h-5 w-5 mr-2 mt-0.5 text-slate-900 dark:text-white" />
                  <span>{t('footer.address')}</span>
                </div>
                <div className="flex items-center">
                  <Phone className="h-5 w-5 mr-2 text-slate-900 dark:text-white" />
                  <span>{t('footer.phone')}</span>
                </div>
                <div className="flex items-center">
                  <Mail className="h-5 w-5 mr-2 text-slate-900 dark:text-white" />
                  <span>{t('footer.email')}</span>
                </div>
              </div>
            </div> */}

            {/* AI Models */}
            <div>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-4">{t('header.ai_models')}</h3>
              <ul className="space-y-2">
                <li>
                  <a href="/fire-model-details" className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-300">
                    {t('header.fire_smoke')}
                  </a>
                </li>
                <li>
                  <a href="/fall-model-details" className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-300">
                    {t('header.fall_detection')}
                  </a>
                </li>
                <li>
                  <a href="/violence-model-details" className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-300">
                    {t('header.violence_detection')}
                  </a>
                </li>
                <li>
                  <a href="/shoplift-model-details" className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-300">
                    {t('header.shoplifting', { defaultValue: t('header.shoplifting') })}
                  </a>
                </li>
              </ul>
            </div>

            {/* Solutions */}
            <div>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-4">{t('header.solutions')}</h3>
              <ul className="space-y-2">
                <li>
                  <a href="/technology-partners" className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-300">
                    {t('header.technology_partners')}
                  </a>
                </li>
                <li>
                  <a href="/gateway" className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-300">
                    {t('header.gateway')}
                  </a>
                </li>
              </ul>
            </div>

            {/* Main Navigation */}
            <div>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-4">{t('footer.quickLinks', { defaultValue: 'Quick Links' })}</h3>
              <ul className="space-y-2">
                {/* <li>
                  <a href="http://localhost:4001" className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-300">
                    {t('header.api')}
                  </a>
                </li> */}
                {/* <li>
                  <a href="https://billing.oleyes.com" className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-300">
                    {t('header.billing')}
                  </a>
                </li> */}
                <li>
                  <a href="https://support.oleyes.com" className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-300">
                    {t('header.support')}
                  </a>
                </li>
                <li>
                  <Link href="/contact-sales" className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-300">
                    {t('header.contact_sales')}
                  </Link>
                </li>
               
              </ul>
            </div>

            {/* Company Links */}
            <div>
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-4">{t('footer.company', { defaultValue: 'Company' })}</h3>
              <ul className="space-y-2">
                <li>
                  <Link href="/about-us" className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-300">
                    {t('header.about_us', { defaultValue: t('header.about', { defaultValue: 'About' }) })}
                  </Link>
                </li>
                <li>
                  <Link href="/careers" className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-300">
                    {t('header.careers', 'Careers')}
                  </Link>
                </li>
                <li>
                  <Link href="/terms-conditions" className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-300">
                    {t('footer.terms', { defaultValue: 'Terms' })}
                  </Link>
                </li>
                <li>
                  <Link href="/privacy-policy" className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-300">
                    {t('footer.privacy', { defaultValue: 'Privacy' })}
                  </Link>
                </li>
                <li>
                  <Link href="/cookies-policy" className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-300">
                    {t('footer.cookies', { defaultValue: 'Cookies' })}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 pb-8 border-t border-gray-700">
          <p className="text-center text-sm text-gray-400">
            &copy; {new Date().getFullYear()} {t('footer.companyName', { defaultValue: 'Oleyes Security' })}. {t('footer.copyright', { defaultValue: 'All rights reserved' })}.
            <Link href="/terms-conditions" className="text-sm px-2 text-gray-500 dark:text-gray-400 hover:text-gray-300 underline">
              {t('footer.terms', { defaultValue: 'Terms' })}
            </Link>
            <Link href="/privacy-policy" className="text-sm px-2 text-gray-500 dark:text-gray-400 hover:text-gray-300 underline">
              {t('footer.privacy', { defaultValue: 'Privacy' })}
            </Link>
            <Link href="/cookies-policy" className="text-sm px-2 text-gray-500 dark:text-gray-400 hover:text-gray-300 underline">
              {t('footer.cookies', { defaultValue: 'Cookies' })}
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}